import React, { Component } from 'react';
import { message, Input } from 'antd';
import { createHistory } from 'react-router'
import './style.scss';
const { Search } = Input;

import cookie from 'react-cookies'
export default class SearchBar extends Component {
  constructor(props){
    super(props);
    this.state={
      searchFocus: false,
      keyword: ''
    }
  }
  componentDidUpdate() {

    }
  inputOnFocus = () => {
    this.setState({
      searchFocus: true
    })
  }

  inputOnBlur = () => {
    this.setState({
      searchFocus: false
    })
  }

  onSearchChange = (e) => {
    this.setState({
      keyword:e.target.value
    })
  }

  onSearch = (e) => {
    if (e === ''){
      message.error('请输入搜索词');
    }
    else {
      window.location.href = '/search/' + e + ''
    }
  }

  render() {
    const {searchFocus,keyword} =this.state
        const {inputOnFocus,inputOnBlur,onSearchChange,onSearch} = this
        return(
          <div className="search-bar" style={{'paddingLeft': searchFocus ? '40px' : '0px','width': searchFocus ? '260px' : '260px'}}>
            <Search className={`search-bar-block`} allowClear={true} bordered={false} placeholder="搜索书名" size="large" onSearch={onSearch} enterButton />
          </div>
        )
    }
}
